import { Theme as SelectTheme, StylesConfig } from 'react-select';

export const linkClassName = 'text-indigo-600 underline';

export const h2ClassName = 'text-gray-800 text-lg font-semibold mt-6 mb-1';
export const h2WhiteBoxClassName =
  'text-gray-800 text-lg leading-4 font-semibold mb-4';

export const hardButtonClassName =
  ' ' +
  ' rounded-md px-3.5 py-2.5 text-sm font-semibold  ' +
  ' shadow-xs  focus-visible:outline focus-visible:outline-2  ' +
  ' bg-indigo-600 text-white ' +
  ' focus-visible:outline-offset-2 hover:bg-indigo-500 focus-visible:outline-indigo-600 ' +
  ' disabled:bg-indigo-200 ';
export const softButtonClassName =
  ' ' +
  ' rounded-md px-3.5 py-2.5 text-sm font-semibold  ' +
  ' shadow-xs focus-visible:outline focus-visible:outline-2  ' +
  ' bg-white text-indigo-600 border border-indigo-600  ' +
  ' hover:bg-indigo-100' +
  ' focus-visible:outline-offset-2 hover:border-indigo-700 focus-visible:outline-indigo-800 ' +
  ' disabled:bg-indigo-200 disabled:cursor-wait disabled:text-indigo-300';

export const inputClassName = `
  block w-full border-0 py-1.5 sm:text-sm sm:leading-6 rounded-md shadow-xs
  text-gray-900 ring-1 ring-inset ring-gray-300
  placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600
  
  pl-3 bg-transparent appearance-none border-gray-500
`;

export const selectTheme = (theme: SelectTheme): SelectTheme => ({
  colors: {
    ...theme.colors,
    primary: '#4f46e5',
    primary25: '#e9e9e988',
    primary50: '#e9e9e9',
    neutral20: '#e9e9e9',
  },
  borderRadius: 8,
  spacing: {
    ...theme.spacing,
    controlHeight: 40,
  },
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const selectStyles: StylesConfig<any, boolean, any> = {
  control: (base, state) => ({
    ...base,
    boxShadow: state.isFocused
      ? '0px 0px 0px 2px var(--color-ring-focus)'
      : 'none',
    padding: '1px 4px',
    fontSize: '14px',
  }),
  menu: (base) => ({
    ...base,
    fontSize: '14px',
  }),
};
